export interface Cliente {
  [key:string] : string | number | undefined | Date;
  CA1COD: string;
  CA1LOJA: string;
  CA1NOME: string;
  CA1NREDUZ: string;
  CA1CONTATO: string;
  CA1TIPO: string;
  DA1DTNASC: Date | undefined;
  NA1LC: number;
  CA1CEP: string;
  CA1END: string;
  CA1COMPLEM: string;
  CA1BAIRRO: string;
  CA1EST: string;
  CA1ESTADO: string;
  CA1COD_MUN: string;
  CA1MUN: string;
  CA1CGC: string;
  CA1INSCR: string;
  CA1INSCRM: string;
  CA1PFISICA: string;
  CA1DDD: string;
  CA1TEL: string;
  CA1NATUREZ: string;
  CA1CONTA: string;
  CA1EMAIL: string;
  CA1CODPAIS: string;
  CA1PAIS: string;
  CA1CXPOSTA: string;
  CA1DDI: string;
  CA1FAX: string;
  CA1HPAGE: string;
  CA1PESSOA: string;
  CA1RG: string;
  CA1MSBLQL: string;
  NA1RECNO: number;
}

export const getClienteDefault = (): Cliente => {
  return {
    CA1COD: '',
    CA1LOJA: '',
    CA1NOME: '',
    CA1NREDUZ: '',
    CA1CONTATO: '',
    CA1TIPO: '',
    DA1DTNASC: undefined,
    NA1LC: 0,
    CA1CEP: '',
    CA1END: '',
    CA1COMPLEM: '',
    CA1BAIRRO: '',
    CA1EST: '',
    CA1ESTADO: '',
    CA1COD_MUN: '',
    CA1MUN: '',
    CA1CGC: '',
    CA1INSCR: '',
    CA1INSCRM: '',
    CA1PFISICA: '',
    CA1DDD: '',
    CA1TEL: '',
    CA1NATUREZ: '',
    CA1CONTA: '',
    CA1EMAIL: '',
    CA1CODPAIS: '',
    CA1PAIS: '',
    CA1CXPOSTA: '',
    CA1DDI: '',
    CA1FAX: '',
    CA1HPAGE: '',
    CA1PESSOA: '',
    CA1RG: '',
    CA1MSBLQL: '',
    NA1RECNO: 0,
  }
}

export interface ClienteLista {
  items: Array<Cliente>;
  hasNext: boolean;
}
